import { fetchAuthSession } from 'aws-amplify/auth'

declare const APP_NAME: string

export default defineNuxtRouteMiddleware(async (to, from) => {
  const userState = useUserState()

  const { idToken: { payload: { sub, email } = { sub: undefined, email: undefined } } = {} } = (await fetchAuthSession()).tokens ?? {}

  userState.value = sub && email
    ? {
        sub,
        email: String(email),
      }
    : undefined

  if (APP_NAME === 'investor-app' && userState.value && typeof to.name === 'string' && to.name?.startsWith('auth-')) {
    return navigateTo({ path: '/', query: { ...from.query }, hash: from.hash })
  }

  if (APP_NAME === 'investor-app' && !userState.value && typeof to.name === 'string' && !to.name?.startsWith('auth-')) {
    return navigateTo({ path: '/auth/login', query: { ...from.query }, hash: from.hash })
  }
})
